/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {BreadcrumbSingle, BreadcrumbMultiple, BreadcrumbMultipleData, BreadcrumbVariants, BreadcrumbCollapseOpen} from 'Docs/uilib/components/breadcrumb/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    code: "code",
    a: "a",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Multiple Breadcrumb (recommended)"
    }), "\n", _jsxs(_components.p, {
      children: ["To ensure the correct use of the Breadcrumb, we recommend passing down pages as a variable to ", _jsx(_components.code, {
        children: "data"
      }), ". If you have other specific cases, check out how to customize with ", _jsx(_components.a, {
        href: "/uilib/components/breadcrumb/#multiple-breadcrumb-with-children",
        children: "children in Multiple Breadcrumb"
      }), "."]
    }), "\n", _jsx(BreadcrumbMultipleData, {}), "\n", _jsx(_components.p, {
      children: "Some extra functionality is provided to this variant:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["The first item, ", _jsx(_components.code, {
          children: "Home"
        }), ", gets assigned a home icon and an appropriate text label based on the current locale."]
      }), "\n", _jsx(_components.li, {
        children: "The last item in pages will be static text, corresponding to the current page."
      }), "\n", _jsxs(_components.li, {
        children: ["Another variant, ", _jsx(_components.code, {
          children: "collapse"
        }), ", appears for small screens."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Single Breadcrumb"
    }), "\n", _jsxs(_components.p, {
      children: ["When you only want a single button for ", _jsx(_components.code, {
        children: "back"
      }), ", this variant is recommended and default when neither ", _jsx(_components.code, {
        children: "data"
      }), " nor ", _jsx(_components.code, {
        children: "children"
      }), " is present."]
    }), "\n", _jsx(BreadcrumbSingle, {}), "\n", _jsx(_components.h3, {
      children: "Multiple Breadcrumb with children"
    }), "\n", _jsx(_components.p, {
      children: "For customizing the Breadcrumb to fit your needs, this variant can be utilized."
    }), "\n", _jsx(BreadcrumbMultiple, {}), "\n", _jsx(_components.h3, {
      children: "Setting property 'variant'"
    }), "\n", _jsxs(_components.p, {
      children: ["Property variant is by default set based on the combination of children and data properties, and also screen size.\nIf you want to override this property, pass in the prop ", _jsx(_components.code, {
        children: "variant"
      }), " to be either ", _jsx(_components.code, {
        children: "single"
      }), ", ", _jsx(_components.code, {
        children: "multiple"
      }), ", or ", _jsx(_components.code, {
        children: "collapse"
      }), "."]
    }), "\n", _jsx(BreadcrumbVariants, {}), "\n", _jsx(_components.h3, {
      children: "Setting property 'variant' and overriding 'isCollapsed'"
    }), "\n", _jsx(BreadcrumbCollapseOpen, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
